var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_111_494)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_111_494",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_111_494",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_111_494",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACJ0lEQVR4nO2dsW4TQRRFXxX4BAx8YgJdzB+ktmTJ71orud+Sii8AUgV+gh6ZAlcbjeJIYQV4bWVndp7PkW6z8s6Mj2bfWq8YmwEAAAAAAAAAwB8sFosXkt5JunX3X5K6muMP3+Gru1+l72ZTYL1ev3X376XlaDzpd6vV6k1RyZvN5mVkyXoiu+jOlvS+tATly2VJ0bcTENBl2tVfSorelhagfNmWFN2dUwzRQnSkGKKF6EgxRAvRkWKIFqIjxWoR7e47SddN07xOcff5/tq/7vn9+PnnWvPAeasXPe+Pka79557rsdZ+YN66RUua9cdYLpevjvn8c3Fg3rpFN38pAampXkL0gXnjlQ5JH0qUjgPzVi96l2TzMhy/Rnc1B9FCdKgYooXoSDFEC9GRYogWoiPFahHttEmziZ73x6BNOoATHr9ZfwzapAM4dqENbdJypUO0SUcRvaNNmqdGdzUH0UJ0qBiihehIMUQL0ZFiiBaiI8VqEe20SbOJnvfHoE06gBMev1l/DNqkAzh2oQ1t0nKlQ7RJRxG9o02ap0Z3NQfRQnSoGKKF6EgxRAvRkWKIFqIjxQqKPqfj2H6WFM0BgznYn7DbnUkurfBxxt/OYDfftW17YaWPNY4s26dwrPHTnZ0OtU51LMgLcivpcyoXxXfymLRteyHp4wm771M607r0+kPLdiSfzlDZSM4g25E8vmxH8mi/2W8k/djnZjJ/3QEAAABgU+EeUQTCxFye0b8AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopup);
export default __webpack_public_path__ + "static/media/Popup.1a099df6fbc7c8822d40623c88657310.svg";
export { ForwardRef as ReactComponent };